export default __webpack_public_path__ + "static/media/Group1633.55b825bc.png";